import { createActions, createReducer, resettableReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  data: {},
  error: null,
  activeCity: '',
  activeCityId: ''
};

const { Types, Creators } = createActions(
  {
    reset: [],
    getCityList: ['provinceName'],
    getCityListRequest: ['provinceName'],
    getCityListSuccess: ['data'],
    getCityListFailure: ['error'],
    setActiveCity: ['activeCity', 'activeCityId']
  },
  { prefix: 'cb/getCityList/' },
);

export { Types as types, Creators as actions };

export const setActiveCity = (state, { activeCity, activeCityId }) => {
  return {
    ...state,
    activeCity,
    activeCityId
  };
};

export const request = state => {
  return {
    ...state,
    fetching: true,
  };
};

export const success = (state, action) => {
  const { data } = action;
  return {
    fetching: false,
    fetched: true,
    activeCity: state.activeCity,
    activeCityId: state.activeCityId,
    data,
    error: INITIAL_STATE.error,
  };
};

export const getFailure = (options = { reset: false }) => (state, action) => {
  const { error } = action;
  return {
    fetching: false,
    fetched: options.reset ? INITIAL_STATE.fetched : state.fetched,
    data: options.reset ? INITIAL_STATE.data : state.data,
    error,
  };
};

export const HANDLERS = {
  [Types.GET_CITY_LIST_REQUEST]: request,
  [Types.GET_CITY_LIST_SUCCESS]: success,
  [Types.GET_CITY_LIST_FAILURE]: getFailure(true),
  [Types.SET_ACTIVE_CITY]: setActiveCity
};

export default resettableReducer(Types.RESET)(
  createReducer(INITIAL_STATE, HANDLERS),
);
